import { render, staticRenderFns } from "./PlayersNav.vue?vue&type=template&id=fb552ea4&scoped=true&"
import script from "./PlayersNav.vue?vue&type=script&lang=js&"
export * from "./PlayersNav.vue?vue&type=script&lang=js&"
import style0 from "./PlayersNav.vue?vue&type=style&index=0&id=fb552ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb552ea4",
  null
  
)

export default component.exports